import React, { useState, useEffect } from "react";
import {
  View,
  TextInput,
  FlatList,
  TouchableOpacity,
  Text,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import middlewareAPI from "../../services/middleware";

interface Props {
  compRef: any;
  onLocationSelected: (data, details) => void;
  placeholder: string;
  leftIcon: boolean;
  rightIcon: boolean;
  inline?: boolean;
  darkBackgroundColor?: string;
  darkBorderColor?: string;
  queryType?: string;
  toggle?: boolean;
  setToggle?: (value: boolean) => void;
}

const GoogleAutocomplete: React.FC<Props> = ({
  compRef,
  onLocationSelected,
  placeholder = "Search",
  leftIcon = false,
  rightIcon = false,
  inline = false,
  darkBackgroundColor = "#616161",
  darkBorderColor = "#fff",
  queryType = "geocode",
  toggle = false,
  setToggle = () => console.log("add function"),
}) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Function to fetch suggestions from the Google Places API
  const fetchSuggestions = async (input: string) => {
    if (input?.length < 3) {
      setSuggestions([]);
      return;
    }

    setLoading(true);

    try {
      const response = await middlewareAPI.post(
        "googleAutocomplete/PlaceSuggestions",
        { input: input }
      );
      setSuggestions(response?.data?.predictions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <View style={styles.container}>
      <TextInput
        style={styles.input}
        placeholder={placeholder}
        value={query}
        onChangeText={(text) => {
          setQuery(text);
          fetchSuggestions(text);
        }}
      />

      {/* Show a loading spinner while fetching */}
      {loading && <ActivityIndicator size="small" color="#0000ff" />}

      {/* Render list only if there are suggestions */}

      <FlatList
        data={suggestions}
        keyExtractor={(item) => item.place_id}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.suggestionItem}
            onPress={() => {
              setQuery(item.description); // Set the selected suggestion
              setSuggestions([]); // Clear suggestions immediately
              onLocationSelected(null, item); // Callback to parent component
            }}
          >
            <Text>{item.description}</Text>
          </TouchableOpacity>
        )}
        contentContainerStyle={{
          borderLeftColor: suggestions?.length > 0 ? "#ccc" : "transparent",
          borderLeftWidth: 1,
          borderRightColor: suggestions?.length > 0 ? "#ccc" : "transparent",
          borderRightWidth: 1,
          minHeight: 200,
          maxWidth: 335,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 4,
    padding: 10,
    marginBottom: 10,
    width: 335,
  },
  suggestionItem: {
    padding: 10,
    borderBottomWidth: 1,
    borderColor: "#ccc",
  },
});

export default GoogleAutocomplete;
